import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { useMyLicenses } from '@/hooks/useResellerOrders';

export default function ResellerLicensesPage() {
  const { data: licenses, isLoading } = useMyLicenses();

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">Licenses</h2>
      <Card>
        <CardHeader><CardTitle>Issued licenses</CardTitle></CardHeader>
        <CardContent>
          {isLoading ? (
            <p className="text-muted-foreground">Loading…</p>
          ) : (licenses ?? []).length === 0 ? (
            <p className="text-muted-foreground">No licenses issued yet.</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>License Key</TableHead>
                  <TableHead>Domain</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Issued</TableHead>
                  <TableHead>Expires</TableHead>
                  <TableHead />
                </TableRow>
              </TableHeader>
              <TableBody>
                {(licenses ?? []).map((l) => (
                  <TableRow key={l.id}>
                    <TableCell className="font-mono text-xs">{l.license_key}</TableCell>
                    <TableCell>{l.domain ?? '—'}</TableCell>
                    <TableCell><Badge variant={l.status === 'active' ? 'default' : 'secondary'}>{l.status}</Badge></TableCell>
                    <TableCell className="text-sm text-muted-foreground">{new Date(l.issued_at).toLocaleDateString()}</TableCell>
                    <TableCell className="text-sm text-muted-foreground">{l.expires_at ? new Date(l.expires_at).toLocaleDateString() : 'Never'}</TableCell>
                    <TableCell>
                      <Button size="sm" variant="ghost" onClick={() => { navigator.clipboard.writeText(l.license_key); toast.success('Copied'); }}>
                        <Copy className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
